export default {
  get_all: { method: "get", url: "api/discricionaria-legal" },
  show: { method: "get", url: "api/discricionaria-legal{/id}" },
  store: { method: "post", url: "api/discricionaria-legal" },
  update: { method: "put", url: "api/discricionaria-legal{/id}" },
  update_extraction_status: {
    method: "put",
    url: "api/discricionaria-legal/oportunidades/status-extracao",
  },
  delete: { method: "delete", url: "api/discricionaria-legal{/id}" },
};
